<template>
  <div class="">
    <!-- Main Form Card -->
    <div class="form-card">
      <!-- Device Information Section -->
      <div class="section-header mb-4">
        <i class="bi bi-info-circle-fill me-2"></i>
        <h5 class="mb-0">Device Information</h5>
      </div>

      <div class="row g-4 mb-5">
        <div class="col-lg-6">
          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-pc-display me-2"></i>Device Name
            </label>
            <input 
              type="text" 
              class="custom-input" 
              placeholder="Enter device name" 
              v-model="device.name"
            >
          </div>

          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-upc-scan me-2"></i>Serial Number
            </label>
            <input 
              type="text" 
              class="custom-input" 
              placeholder="Enter serial number" 
              v-model="device.customer"
            >
          </div>

          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-cpu me-2"></i>Model
            </label>
            <input 
              type="text" 
              class="custom-input" 
              placeholder="Enter model" 
              v-model="device.model"
            >
          </div>

          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-mailbox me-2"></i>Postcode
            </label>
            <input 
              type="text" 
              class="custom-input" 
              placeholder="Enter postcode" 
              v-model="device.postcode"
            >
          </div>
        </div>

        <div class="col-lg-6">
          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-geo-alt me-2"></i>Location
            </label>
            <input 
              type="text" 
              class="custom-input" 
              placeholder="Enter location" 
              v-model="device.location"
            >
          </div>

          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-map me-2"></i>Province
            </label>
            <input 
              type="text" 
              class="custom-input" 
              placeholder="Enter province" 
              v-model="device.province"
            >
          </div>

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="custom-label">
                <i class="bi bi-compass me-2"></i>Latitude
              </label>
              <input 
                type="number" 
                step="0.000001" 
                class="custom-input" 
                placeholder="0.000000" 
                v-model="device.Latitude"
              >
            </div>

            <div class="col-md-6 mb-4">
              <label class="custom-label">
                <i class="bi bi-compass-fill me-2"></i>Longitude
              </label>
              <input 
                type="number" 
                step="0.000001" 
                class="custom-input" 
                placeholder="0.000000" 
                v-model="device.Longitude"
              >
            </div>
          </div>

          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-journal-text me-2"></i>Description
            </label>
            <textarea 
              class="custom-input" 
              rows="3" 
              placeholder="Enter description..." 
              v-model="device.description"
            ></textarea>
          </div>
        </div>
      </div>


      <div class="section-header mb-3">
        <i class="bi bi-broadcast-pin me-2"></i>
        <h5 class="mb-0">Communication Settings</h5>
      </div>

      <div class="row g-4 mb-5">
        <div class="col-lg-6">
          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-arrow-left-right me-2"></i>Communication Type
            </label>
            <select 
              class="custom-input" 
              v-model="device.mode" 
              @change="generateKey_MQTT()"
            >
              <option value="mqtt">MQTT</option>
              <option value="api">API</option>
            </select>
          </div>

          <!-- MQTT Configuration -->
          <div v-if="device.mode=='mqtt'" class="config-box">
            <div class="config-header">
              <i class="bi bi-router me-2"></i>
              <strong>MQTT Configuration</strong>
            </div>

            <div class="config-item">
              <label class="config-label">Topic</label>
              <div class="input-group-custom">
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="Enter topic" 
                  v-model="mqtt.topic"
                >
                <button 
                  class="btn-copy" 
                  @click="copyTextFallback(mqtt.topic)"
                >
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
            </div>

            <div class="config-item">
              <label class="config-label">Client ID</label>
              <div class="input-group-custom">
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="Auto-generated" 
                  v-model="mqtt.id"
                >
                <button 
                  class="btn-copy" 
                  @click="copyTextFallback(mqtt.id)"
                >
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
            </div>

            <div class="config-item">
              <label class="config-label">Username</label>
              <div class="input-group-custom">
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="Auto-generated" 
                  v-model="mqtt.username"
                >
                <button 
                  class="btn-copy" 
                  @click="copyTextFallback(mqtt.username)"
                >
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
            </div>

            <div class="config-item">
              <label class="config-label">Password</label>
              <div class="input-group-custom">
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="Auto-generated" 
                  v-model="mqtt.password"
                >
                <button 
                  class="btn-copy" 
                  @click="copyTextFallback(mqtt.password)"
                >
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- API Configuration -->
          <div v-else class="config-box">
            <div class="config-header">
              <i class="bi bi-plugin me-2"></i>
              <strong>API Configuration</strong>
            </div>

            <div class="mb-3">
              <label class="custom-label">
                <i class="bi bi-key me-2"></i>Authentication Type
              </label>
              <select class="custom-input" v-model="api.mode">
                <option value="apikey">API Key</option>
                <option value="basic">Basic Authentication</option>
              </select>
            </div>

            <!-- API Key Mode -->
            <div v-if="api.mode=='apikey'">
              <div class="mb-3">
                <label class="config-label">Key Location</label>
                <select class="custom-input-small" v-model="api.in">
                  <option value="header">Header</option>
                  <option value="query">Query Parameter</option>
                </select>
              </div>

              <div class="mb-3">
                <label class="config-label">Key Name</label>
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="e.g. X-API-Key" 
                  v-model="api.key"
                >
              </div>

              <div class="mb-3">
                <label class="config-label">Key Value</label>
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="Enter API key value" 
                  v-model="api.value"
                >
              </div>
            </div>

            <!-- Basic Auth Mode -->
            <div v-else-if="api.mode=='basic'">
              <div class="mb-3">
                <label class="config-label">Username</label>
                <input 
                  type="text" 
                  class="custom-input-small" 
                  placeholder="Enter username" 
                  v-model="api.username"
                >
              </div>

              <div class="mb-3">
                <label class="config-label">Password</label>
                <input 
                  type="password" 
                  class="custom-input-small" 
                  placeholder="Enter password" 
                  v-model="api.password"
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-file-text me-2"></i>Template
            </label>
            <select class="custom-input" v-model="device.template_id">
              <option value="" disabled>Select a template</option>
              <option v-for="item in list_template" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="mb-4">
            <label class="custom-label">
              <i class="bi bi-chat-left-text me-2"></i>Additional Notes
            </label>
            <textarea 
              class="custom-input" 
              rows="6" 
              placeholder="Add any additional notes..." 
              v-model="device.comment"
            ></textarea>
          </div>

          <!-- Info Box -->
          <div class="info-box">
            <i class="bi bi-lightbulb text-warning me-2"></i>
            <div>
              <strong>Configuration Tip:</strong>
              <p class="mb-0 mt-1">Make sure your device credentials are secure. For MQTT, credentials are auto-generated for security.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="button-row mt-4">
        <button @click="clearForm()" class="btn-clear">
          <i class="bi bi-arrow-counterclockwise me-2"></i>Clear Form
        </button>
        <button 
          @click="createDevice()" 
          class="btn-create"
          :disabled="!device.name"
        >
          <i class="bi bi-check-circle me-2"></i>Create Device
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      list_template: [],
      list_plan: [],
      device: {
        template_id: "",
        plan_id: "",
        name: "",
        customer: "",
        model: "",
        postcode: "",
        location: "",
        province: "",
        Latitude: "",
        Longitude: "",
        description: "",
        note: "",
        mode: "api",
        comment: ""
      },
      api: {
        mode: "basic",
        in: "",
        key: "",
        value: "",
        username: "",
        password: ""
      },
      mqtt: {
        id: "cxaksjyteqhw",
        topic: "",
        username: "",
        password: ""
      }
    }
  },
  methods: {
    clearForm() {
      this.device = {
        template_id: "",
        plan_id: "",
        name: "",
        customer: "",
        model: "",
        postcode: "",
        location: "",
        province: "",
        Latitude: "",
        Longitude: "",
        description: "",
        note: "",
        mode: "api",
        comment: ""
      };
      this.api = {
        mode: "basic",
        in: "",
        key: "",
        value: "",
        username: "",
        password: ""
      };
      this.mqtt = {
        id: "",
        topic: "",
        username: "",
        password: ""
      };
    },

    async getTemplateList() {
      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        });
        const data = await response.json();
        console.log("success:", data);
        this.list_template = data.data;
      } catch (error) {
        console.error("Upload error:", error);
      }
    },

    async getPlanList() {
      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan`, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        });
        const data = await response.json();
        console.log("success:", data);
        this.list_plan = data.data;
      } catch (error) {
        console.error("Upload error:", error);
      }
    },

    generateKey_MQTT() {
      this.mqtt.id = CryptoJS.lib.WordArray.random(8).toString(CryptoJS.enc.Base64);
      this.mqtt.username = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64);
      this.mqtt.password = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64);
    },

    copyTextFallback(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      
      // Optional: Show a visual feedback
      alert("Copied to clipboard!");
    },

    async createDevice() {
      try {
        var body_create_device;
        if (this.device.mode == 'api') {
          if (this.api.mode == 'apikey') {
            body_create_device = {
              "name": this.device.name,
              "template_id": this.device.template_id,
              "plan_id": this.device.plan_id,
              "comment": this.device.comment,
              "mode": this.device.mode,
              "config": {
                "auth": {
                  "type": this.api.mode,
                  "in": this.api.in,
                  "key": this.api.key,
                  "value": this.api.value
                }
              }
            }
          } else {
            body_create_device = {
              "name": this.device.name,
              "template_id": this.device.template_id,
              "plan_id": this.device.plan_id,
              "comment": this.device.comment,
              "mode": this.device.mode,
              "config": {
                "auth": {
                  "type": this.api.mode,
                  "username": this.api.username,
                  "password": this.api.password,
                }
              }
            }
          }
        } else if (this.device.mode == 'mqtt') {
          body_create_device = {
            "name": this.device.name,
            "template_id": this.device.template_id,
            "plan_id": this.device.plan_id,
            "comment": this.device.comment,
            "mode": this.device.mode,
            "config": {
              "topic": this.mqtt.topic,
              "clientId": this.mqtt.id,
              "username": this.mqtt.username,
              "password": this.mqtt.password,
            }
          }
        }

        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
          body: JSON.stringify(body_create_device)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        this.$router.push('/settings/device/list');

        console.log('Dashboard page created:', result);
      } catch (error) {
        console.error('Error creating dashboard page:', error);
      }
    },
  },
  created() {
    this.getTemplateList();
    this.getPlanList();
  }
}
</script>

<style scoped>

/* Header Card */
.header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
  color: white;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  backdrop-filter: blur(10px);
}

.header-card h3 {
  color: white;
  margin: 0;
}

.header-card p {
  color: rgba(255, 255, 255, 0.9);
}

/* Form Card */
.form-card {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  color: #2d3748;
  font-weight: 600;
}

.section-header i {
  color: #667eea;
  font-size: 1.3rem;
}

.section-divider {
  height: 2px;
  background: linear-gradient(to right, #e2e8f0, transparent);
  margin: 2rem 0;
}

/* Custom Input Styles */
.custom-label {
  display: block;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.custom-input {
  width: 100%;
  padding: 0.85rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: #fafafa;
}

.custom-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
  color: #a0aec0;
}

textarea.custom-input {
  resize: vertical;
}

select.custom-input {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

/* Configuration Box */
.config-box {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.config-header {
  display: flex;
  align-items: center;
  color: #2d3748;
  font-size: 1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e2e8f0;
}

.config-header i {
  color: #667eea;
}

.config-item {
  margin-bottom: 1rem;
}

.config-label {
  display: block;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 0.4rem;
  font-size: 0.85rem;
}

.custom-input-small {
  width: 100%;
  padding: 0.65rem 0.85rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: white;
}

.custom-input-small:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

select.custom-input-small {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.85rem center;
  padding-right: 2.5rem;
}

.input-group-custom {
  display: flex;
  gap: 0.5rem;
}

.input-group-custom .custom-input-small {
  flex: 1;
}

.btn-copy {
  padding: 0.65rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.btn-copy:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Info Box */
.info-box {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 1.25rem;
  border-radius: 10px;
  display: flex;
  align-items: start;
  border-left: 4px solid #f59e0b;
  margin-top: 1rem;
}

.info-box i {
  font-size: 1.5rem;
  margin-top: 0.1rem;
}

.info-box strong {
  color: #92400e;
  display: block;
}

.info-box p {
  color: #78350f;
  font-size: 0.9rem;
}

/* Buttons */
.button-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 2px solid #e2e8f0;
}

.btn-clear {
  padding: 0.85rem 2rem;
  border: 2px solid #e2e8f0;
  background: white;
  color: #718096;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-clear:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
  color: #2d3748;
  transform: translateY(-1px);
}

.btn-create {
  padding: 0.85rem 2.5rem;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-create:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.btn-create:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
  .form-card {
    padding: 1.5rem;
  }
  
  .header-card {
    padding: 1.5rem;
  }
  
  .button-row {
    flex-direction: column-reverse;
  }
  
  .btn-clear,
  .btn-create {
    width: 100%;
    justify-content: center;
  }

  .input-group-custom {
    flex-direction: column;
  }

  .btn-copy {
    width: 100%;
  }
}
</style>